export const ACTIONS = {
  Clear: "CLEAR",
  ChangeFilters: "CHANGE_FILTERS",
  GetProducts: "GET_PRODUCTS",
  GetCategories: "GET_CATEGORIES",
  SetCart: "SET_CART",
  SetOrder: "SET_ORDER",
  SetWishlist: "SET_WISHLIST",
  SetAddress: "SET_ADDRESS",
};

export const FILTERS = {
  SortBy: "sortBy",
  Categories: "categories",
  Rating: "rating",
  PriceRange: "priceRange",
  Search: "search",
};

export const CARTQUANTITY = {
  Increment: "increment",
  Decrement: "decrement",
};

export const Categories = {
  kimono: "Kimono",
  clothes: "Clothes",
  headband: "Headband",
  shuriken: "Shuriken",
  kunai: "Kunai",
};

export const SortBy = {
  LowToHigh: "Low-to-High",
  HighToLow: "High-to-Low",
};
